export default __webpack_public_path__ + "static/media/e-bupot-logotype-l.b146b250.svg";